import React from 'react';
import detectOldIOS from '#/shared/utils/detect-old-ios';
import * as Styled from './styled';

function StopSignListSkeletons() {
  const needsIOSStyles = detectOldIOS();
  const skeletonWithWrapper = first => {
    return (
      <Styled.StopSignListSkeletonWrapper
        needsIOSStyles={needsIOSStyles}
        first={first}
      >
        <Styled.StopSignListSkeletonCircle />
        <Styled.StopSignListSkeletonLine />
      </Styled.StopSignListSkeletonWrapper>
    );
  };

  return (
    <>
      {skeletonWithWrapper(true)}
      {skeletonWithWrapper(false)}
    </>
  );
}

export default StopSignListSkeletons;
